function r(r, e) {
  (null == e || e > r.length) && (e = r.length);

  for (var t = 0, n = new Array(e); t < e; t++) {
    n[t] = r[t];
  }

  return n;
}

function e() {
  var r = new Map();
  return function (e, t) {
    try {
      var n,
          o = function o(_o) {
        if (n) return _o;
        var i = r.get(e.did);
        return void 0 !== i ? i : Promise.resolve(t()).then(function (t) {
          return null !== t && r.set(e.did, t), t;
        });
      },
          i = function () {
        if (e.params && "true" === e.params["no-cache"]) return n = 1, Promise.resolve(t());
      }();

      return Promise.resolve(i && i.then ? i.then(o) : o(i));
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

function t(r, e) {
  return e();
}

var n = new RegExp("^did:([a-zA-Z0-9_]+):([a-zA-Z0-9_.-]+(:[a-zA-Z0-9_.-]+)*)((;[a-zA-Z0-9_.:%-]+=[a-zA-Z0-9_.:%-]*)*)(/[^#?]*)?([?][^#]*)?(#.*)?$");

function o(e) {
  if ("" === e || !e) throw new Error("Missing DID");
  var t = e.match(n);

  if (t) {
    var o = {
      did: "did:" + t[1] + ":" + t[2],
      method: t[1],
      id: t[2],
      didUrl: e
    };

    if (t[4]) {
      var i = t[4].slice(1).split(";");
      o.params = {};

      for (var a, u = function (e, t) {
        var n;

        if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
          if (Array.isArray(e) || (n = function (e, t) {
            if (e) {
              if ("string" == typeof e) return r(e, void 0);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, void 0) : void 0;
            }
          }(e))) {
            n && (e = n);
            var o = 0;
            return function () {
              return o >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[o++]
              };
            };
          }

          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        return (n = e[Symbol.iterator]()).next.bind(n);
      }(i); !(a = u()).done;) {
        var c = a.value.split("=");
        o.params[c[0]] = c[1];
      }
    }

    return t[6] && (o.path = t[6]), t[7] && (o.query = t[7].slice(1)), t[8] && (o.fragment = t[8].slice(1)), o;
  }

  throw new Error("Invalid DID " + e);
}

var i = function () {
  function r(r, n) {
    void 0 === r && (r = {}), this.registry = r, this.cache = !0 === n ? e() : n || t;
  }

  return r.prototype.resolve = function (r) {
    try {
      var e,
          t = this,
          n = function n(r) {
        if (e) return r;
        throw new Error("Unsupported DID method: '" + i.method + "'");
      },
          i = o(r),
          a = t.registry[i.method],
          u = function () {
        if (a) return Promise.resolve(t.cache(i, function () {
          return a(i.did, i, t);
        })).then(function (r) {
          if (null == r) throw new Error("resolver returned null for " + i.did);
          return e = 1, r;
        });
      }();

      return Promise.resolve(u && u.then ? u.then(n) : n(u));
    } catch (r) {
      return Promise.reject(r);
    }
  }, r;
}();

export { i as Resolver, e as inMemoryCache, t as noCache, o as parse };